import {
  ReportSection,
  SavedReportSection,
  UserCustomisableChartConfig,
} from 'app/modules/reportDashboards/models';
import { hasPermissionChecker } from 'app/modules/permissions/utils';

export const getSavableReportDashboardConfig = (
  config: ReportSection[],
): SavedReportSection[] =>
  config.map((section) => ({
    id: section.id,
    charts: section.charts.map((chart) => ({
      id: chart.id,
      enabled: chart.enabled,
      chartType: chart.chartType,
    })),
  }));

export const mergeReportDashboardConfig = (
  savedConfig: SavedReportSection[],
  defaultConfig: ReportSection[],
  userPermissions: string[],
): ReportSection[] => {
  const defaultConfigMap = savedConfig.reduce<
    Record<string, Record<string, UserCustomisableChartConfig>>
  >((acc, section) => {
    acc[section.id] = section.charts.reduce(
      (innerAcc, chart) => ({
        ...innerAcc,
        [chart.id]: chart,
      }),
      {},
    );
    return acc;
  }, {});

  return defaultConfig
    .filter((section) => {
      if (section.permissions?.length) {
        // Show section only if user has permission required by section
        return hasPermissionChecker(userPermissions, section.permissions);
      }

      return true;
    })
    .map((section) => {
      const { permissions, ...rest } = section;

      return {
        ...rest,
        charts: section.charts.map((chart) => ({
          ...chart,
          // Check needed to ensure that the latest section and key exist within saved state,
          // else nothing to copy over from saved state
          ...(defaultConfigMap[section.id] &&
          defaultConfigMap[section.id][chart.id]
            ? defaultConfigMap[section.id][chart.id]
            : {}),
        })),
      };
    });
};
